export const newhampshireCountiesList = [
    'Belknap',
    'Carroll',
    'Cheshire',
    'Coos',
    'Grafton',
    'Hillsborough',
    'Merrimack',
    'Rockingham',
    'Strafford',
    'Sullivan',
    ]